import { HStack, Text, StackProps, TextProps, Box } from '@chakra-ui/react';
import React from 'react';

import { Typography } from 'packages/common-frontend/components/Typography';
import { colors } from '~/packages/common-frontend/colors';

export const sharedSectionStyles: StackProps = {
  spacing: '24px',
  padding: '16px',
  backgroundColor: colors.millet[50],
  width: '100%',
  borderRadius: '8px',
};

export const sharedInputLabelStyles: TextProps = {
  w: '25%',
  fontWeight: '600',
};

export const OptionalClassWrapper = ({
  isClassed,
  className,
  children,
}: {
  isClassed: boolean;
  className: string;
  children: React.ReactNode;
}) => (
  <>
    {isClassed ? (
      <HStack w="100%" alignItems="flex-start" spacing="24px">
        <Text w="25em" fontWeight="600">
          {className}
        </Text>
        {children}
      </HStack>
    ) : (
      children
    )}
  </>
);

export const SharedInputLabel = ({ label }: { label: string }) => (
  <Box w="25%" alignSelf="flex-start">
    <Typography fontWeight="bold">{label}</Typography>
  </Box>
);
